import { graphql } from 'gatsby';
import React from 'react';
import './list.scss';

interface Props {
  attributes: {
    values: string;
    ordered: boolean;
  };
  innerBlocks: {
    attributes: {
      content: string;
    };
    saveContent: string;
  }[];
}

const List: React.FC<Props> = (props) => {
  const headlineTagName = props.attributes.ordered ? 'ol' : 'ul';
  const HeadlineTag = headlineTagName as keyof JSX.IntrinsicElements;

  const inner = !!props.attributes.values ? props.attributes.values : props.innerBlocks.map((item) => item.saveContent).join('');

  return <HeadlineTag dangerouslySetInnerHTML={{ __html: inner }} className="list" />;
};

export const query = graphql`
  fragment ListBlock on WpCoreListBlock {
    attributes {
      ... on WpCoreListBlockAttributes {
        values
        ordered
      }
    }
    innerBlocks {
      ... on WpCoreListItemBlock {
        attributes {
          content
        }
        saveContent
      }
    }
  }
`;

export default List;
